import {
  StreamlineIcon,
  type StreamlineIconProps,
} from '../streamlineIcon/StreamlineIcon';
import { SmileySimpleSad1 as Svg } from './svgs/SmileySimpleSad1.svg';

export const SmileySimpleSad1 = (props: StreamlineIconProps) => (
  <StreamlineIcon {...props}>
    <Svg />
  </StreamlineIcon>
);
